import React from "react";
import { useNavigate } from "react-router-dom";
import { css } from "@emotion/css";
import { Navbar } from "../../shared/components/navbar/navbar";
import { LoginCard } from "../../features/auth/components/login-card/login-card";
import { usePathHistory } from "../../shared/hooks";

const container = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "calc(100vh - 5.5rem)",
  width: "100%",
  padding: "var(--spacing-xl) var(--spacing-md)",
  backgroundColor: "#FBFBFB",
  '@media (max-width: 480px)': {
    padding: "var(--spacing-xl) 0",
  },
});

const cardWrapper = css({
  width: 'clamp(0px, 100%, 480px)',
  boxSizing: 'border-box',
  '@media (max-width: 920px)': {
    width: 'clamp(0px, 100%, 420px)',
  },
});

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { getPreviousPath } = usePathHistory();
 
  const previousPath = getPreviousPath();

  const handleSuccess = () => {
    navigate(previousPath || "/", { replace: true });
  };

  const redirectUrl = `${window.location.origin}${previousPath || "/"}`;

  return (
    <>
      <Navbar />
      <div className={container}>
        <LoginCard className={cardWrapper} onSuccess={handleSuccess} redirectUrl={redirectUrl} />
      </div>
    </>
  );
};

export default Login;
